import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { StatusCode } from "react-http-status-code";
import "./style.scss";
import logo from "../../../../assets/images/404-images/logo.svg";
import arrow from "../../../../assets/images/404-images/arrow.svg";
import errorWithText from "../../../../assets/images/404-images/404-image-with-text.webp";
import walkingWorker from "../../../../assets/images/404-images/walking-worker.png";
import PublicNavbar from "web/components/PublicNavbar";

const PageNotFound = () => {
  let history = useHistory();

  useEffect(() => {
    document.title = '404 - Page Not Found';
 updateStatusCode();

  }, [])
  const updateStatusCode = () => {
     if (typeof window !== 'undefined') {
     const { history } = window;
    history.replaceState(null, '', '/404');
     history.status = 404;
     }
     };

 
  return (
    <>
     <PublicNavbar />
      <StatusCode code={404}>
        <div className="main-404-container">
          <div className="logo">
            <img
              className=""
              role="button"
              src={logo}
              alt="company logo"
              onClick={() => {
                history.push("/");
              }}
            />
          </div>
          <div className="error-404-image-container">
            <button
              className="go-back-button"
              onClick={() => {
                history.push("/");
              }}
            >
              <img src={arrow} alt="back arrow" />
              Home Page
            </button>
          </div>
          <div className="walking-worker-container"></div>
        </div>
        {/* mobile layout */}
        <div className="mobile-layout-container mt-4">
          <div className="text-center">
            <img
              src={logo}
              role="button"
              alt="logo"
              onClick={() => {
                history.push("/");
              }}
            />
          </div>
          <div>
            <button
              className="go-back-button"
              onClick={() => {
                history.push("/");
              }}
            >
              <img src={arrow} alt="back arrow" />
              Home Page
            </button>
          </div>
          <div style={{ marginTop: "80px" }} className="text-center">
            <img src={errorWithText} alt="404 with text" />
          </div>
          <div className="text-center mt-5">
            <img src={walkingWorker} alt="walking worker" width="100%" />
          </div>
        </div>
      </StatusCode>
    </>
  );
};

export default PageNotFound;
